import { render } from "./ProgramView.vue?vue&type=template&id=fbae491e"
import script from "./ProgramView.vue?vue&type=script&lang=js"
export * from "./ProgramView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__